import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, CheckCircle, Clock, AlertCircle } from 'lucide-react';
import DataTable from '../components/DataTable';
const sequencesData = [{
  id: '1',
  name: 'Analytics Upsell Sequence',
  trigger: 'Potential Analytics Upsell',
  activeContacts: 7,
  status: 'Active',
  lastRun: '2h ago',
  fullTrigger: 'Potential Analytics Upsell (High Manual Reporting)'
}, {
  id: '2',
  name: 'Onboarding Risk Intervention',
  trigger: 'Manufacturer Not Using Assemblies',
  activeContacts: 4,
  status: 'Active',
  lastRun: '6h ago',
  fullTrigger: 'Manufacturer Not Using Assemblies'
}, {
  id: '3',
  name: 'License Overage Billing',
  trigger: 'User Overage - License Limit Exceeded',
  activeContacts: 3,
  status: 'Active',
  lastRun: '12h ago',
  fullTrigger: 'User Overage - License Limit Exceeded'
}, {
  id: '4',
  name: 'High-Value Account Engagement',
  trigger: 'High MRR with Low Feature Adoption',
  activeContacts: 2,
  status: 'Active',
  lastRun: '1 day ago',
  fullTrigger: 'High MRR with Low Feature Adoption'
}, {
  id: '5',
  name: 'New Customer Onboarding Handoff',
  trigger: 'Deal Closed-Won',
  activeContacts: 1,
  status: 'Active',
  lastRun: '1 day ago',
  fullTrigger: 'Deal Closed-Won (A new alert based on a HubSpot deal stage change)'
}, {
  id: '6',
  name: 'Inactive Account Re-engagement',
  trigger: 'Stagnant or Inactive Usage',
  activeContacts: 11,
  status: 'Active',
  lastRun: '3h ago',
  fullTrigger: 'Stagnant or Inactive Usage (e.g., no logins in 30 days)'
}, {
  id: '7',
  name: 'Brand Portal Upsell',
  trigger: 'Potential Brand Portal Upsell',
  activeContacts: 8,
  status: 'Inactive',
  lastRun: '8h ago',
  fullTrigger: 'Potential Brand Portal Upsell (Brand Filter Usage)'
}, {
  id: '8',
  name: 'Low Volume Distributor Check-in',
  trigger: 'Distributor w/ Unusually Low Sales...',
  activeContacts: 6,
  status: 'Active',
  lastRun: '4h ago',
  fullTrigger: 'Distributor with Unusually Low Sales Volume'
}];
const Sequences: React.FC = () => {
  const navigate = useNavigate();
  const handleRowClick = (row: any) => {
    navigate(`/sequences/editor/${row.id}`);
  };
  const handleNewSequence = () => {
    navigate('/sequences/editor/new');
  };
  const columns = [{
    key: 'name',
    label: 'Sequence Name',
    sortable: true
  }, {
    key: 'trigger',
    label: 'Triggering Alert(s)',
    sortable: true
  }, {
    key: 'activeContacts',
    label: 'Active Contacts',
    sortable: true
  }, {
    key: 'status',
    label: 'Status',
    sortable: true,
    render: (value: string) => <div className="flex items-center" data-id="element-1503">
          {value === 'Active' ? <>
              <CheckCircle size={16} className="text-green-500 mr-2" data-id="element-1504" />
              <span data-id="element-1505">Active</span>
            </> : <>
              <AlertCircle size={16} className="text-gray-400 mr-2" data-id="element-1506" />
              <span data-id="element-1507">Inactive</span>
            </>}
        </div>
  }, {
    key: 'lastRun',
    label: 'Last Run',
    sortable: true,
    render: (value: string) => <div className="flex items-center" data-id="element-1508">
          <Clock size={16} className="text-gray-400 mr-2" data-id="element-1509" />
          <span data-id="element-1510">{value}</span>
        </div>
  }];
  return <div className="h-full" data-id="element-1511">
      <div className="flex justify-between items-center mb-6" data-id="element-1512">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1513">Sequences</h1>
        <button onClick={handleNewSequence} className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-1514">
          <Plus size={16} data-id="element-1515" />
          <span data-id="element-1516">New Sequence</span>
        </button>
      </div>
      <div className="bg-white rounded-md shadow" data-id="element-1517">
        <DataTable columns={columns} data={sequencesData} onRowClick={handleRowClick} data-id="element-1518" />
      </div>
    </div>;
};
export default Sequences;